@if (isWarning()) {
  <div
    class="fixed inset-0 z-[100] flex items-center justify-center bg-brand-black/50 px-4"
    aria-modal="true"
    [attr.aria-label]="SESSION_CONST.inactivityWarningTitle"
    data-testid="inactivity-warning-overlay"
  >
    <div
      class="w-full max-w-md rounded-2xl border border-brand-border bg-brand-white p-6 shadow-2xl"
      data-testid="inactivity-warning-dialog"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (mousemove)="$event.stopPropagation()"
    >
      <h2 class="m-0 text-lg font-bold text-brand-black md:text-xl">
        {{ SESSION_CONST.inactivityWarningTitle }}
      </h2>
      <p class="mt-3 text-sm text-brand-gray md:text-base">
        {{ SESSION_CONST.inactivityWarningMessage }}
        <span class="font-semibold text-brand-black" data-testid="inactivity-countdown">
          {{ countdown() }}
        </span>
        {{ SESSION_CONST.inactivityWarningSecondsSuffix }}
      </p>
      <div class="mt-6 flex flex-col gap-3 sm:flex-row">
        <button
          type="button"
          class="w-full cursor-pointer rounded-lg border border-brand-border bg-brand-white px-4 py-3 text-sm font-semibold text-brand-black hover:bg-brand-gray/5"
          (click)="onLogout()"
          (keydown.enter)="onLogout()"
          data-testid="inactivity-logout-button"
        >
          {{ SESSION_CONST.inactivityLogoutButton }}
        </button>
        <button
          type="button"
          class="w-full cursor-pointer rounded-lg bg-brand-primary px-4 py-3 text-sm font-semibold text-white hover:opacity-90"
          (click)="onContinue()"
          (keydown.enter)="onContinue()"
          data-testid="inactivity-continue-button"
        >
          {{ SESSION_CONST.inactivityContinueButton }}
        </button>
      </div>
    </div>
  </div>
}
